// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#columnStrip1').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#columnStrip1').hide('FadeOut');
	}, 1500);
}
